import { render, staticRenderFns } from "./Changes.vue?vue&type=template&id=00b29ed2&scoped=true&"
import script from "./Changes.vue?vue&type=script&lang=js&"
export * from "./Changes.vue?vue&type=script&lang=js&"
import style0 from "./Changes.vue?vue&type=style&index=0&id=00b29ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b29ed2",
  null
  
)

export default component.exports